import { TableAction } from '../../../../components/ModularDataTable/types'
import type { Feature } from '../types'

type ActionsFactoryParams = {
    onEdit: (feature: Feature) => void
    onDelete: (feature: Feature) => void
}

export function createActionsFeatureSpace({ onEdit, onDelete }: ActionsFactoryParams): TableAction[] {
    return [
        {
            icon: 'fas fa-pen',
            label: 'Editar Feature',
            action: (item: Feature) => onEdit(item),
        },
        {
            icon: 'fas fa-trash',
            label: 'Excluir Feature',
            action: (item: Feature) => onDelete(item),
        },
    ]
}